<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong>创建</strong> 产品
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="产品名" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name"
              required></b-form-input>
        </b-form-group>
        <b-form-group label="产品代号" label-for="code">
          <b-form-input id="code" type="text" v-model="data.code"
              required></b-form-input>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check"></i> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-danger"><i class="fa fa-repeat"></i> 复位</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
export default {
  name: 'product-create',
  mixins: [Error],
  data () {
    return {
      data: {
        name: '',
        code: ''
      }
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.$ajax.post(api.getProductCreate(), this.data).then((data) => {
        this.$router.push({name: 'product-list'})
      }, (res) => {
        this.handleError(res)
      })
    },
    onReset (evt) {
      this.data = {
        name: '',
        code: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductCreate.vue?640fe4c4